import React, { FC } from "react";
import { IonSearchbar, IonList, IonListHeader, IonItem } from "@ionic/react"
import { useState } from "react"
import { API_URL } from "../actions/settings";
import "./SearchBarMain.css"

interface IProps {
    mobile?:boolean
};

interface Item {
  'id':string,
  'name':string
}

interface SearchData {
  'buildings': [] | Item[],
  'campuses': [] | Item[],
  'customers': [] | Item[]
}

async function search(token: string,query:string) {
  return fetch(`${API_URL}/search?q=${query}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
           return null

        }
      }).catch(error => {
        console.log(error)
        return null
      });
}

const SearchBarMain:FC<IProps> = ({mobile=false}) => {

    const [data, setData] = useState<SearchData|null>(null)
    
    const [showResults,setShowResults] = useState(false)

    const handleInput = async (e:any) =>{
      
      let query = '';
      const target = e.target as HTMLIonSearchbarElement;
      if (target) query = target.value!.toLowerCase();
      if(query.length>2){
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const res = await search(token,query)
        if(res){
          setData(res['data'])
        }
        setShowResults(true)
      }else{
        setData(null)
      }
    }

    return <div><IonSearchbar
      id='search-bar'
      className='main-search-bar'                        
      animated={true}
      debounce={1000} 
      onIonInput={(event) => handleInput(event)}
      onIonFocus={()=>setShowResults(true)}
      onIonBlur={() => setTimeout(() => setShowResults(false), 200)}
      placeholder="Search Customers, Campuses, or Buildings"
      />
      {showResults && data ?
      <div className={`search-bar-results-${mobile? 'mobile':'pc'}`}>
        <IonList>
        {Object.keys(data).map((key) => {
          
        const items = data[key as keyof SearchData] as Item[];
        if (items.length === 0) return null;
        return (
          <div key={key}>
            <IonListHeader style={{ padding: "8px 16px", fontWeight: "bold", background: "#f0f0f0", textTransform: "capitalize" }}>
              {key}
            </IonListHeader>
            {items.map((item: Item) => (
              <IonItem
                key={item.id}
                className="search-bar-list-item"
                onClick={() => {
                  window.location.href = `/?id=${item.id}&sec=${key}`;
                }}
              >
                {item.name}
              </IonItem>
            ))}
            
          </div>
        );
        })}
        </IonList>
      </div>
      : null}</div>
};

export default SearchBarMain;